/** @format */

import { Route } from "react-router-dom";
import AgentRootBeforeRender from "../pages/common/AgentRootBeforeRender";
import BeforeRender from "../pages/common/BeforeRender";

import { EntryColumn } from "../components/ui_elements/ocnk/Entry/EntryColumn";

// 共通ページ
import NotFound from "../pages/common/NotFound";
import UserRegister from "../pages/common/UserRegister";
import CompletedRegister from "../pages/common/CompletedRegister";
import Login from "../pages/common/Login";
import ResetPassword from "../pages/common/ResetPassword";
import ResetPasswordMail from "../pages/common/ResetPasswordMail";
import ResetPasswordMailCompleted from "../pages/common/ResetPasswordMailCompleted";
import ChangePasswordMail from "../pages/common/ChangePasswordMail";
import EntrySelect from "../pages/ocnk/EntrySelect";
import SystemError from "../pages/common/SystemError";

// おちゃのこ上位固有ページ
import UserRegisterAuthentication from "../pages/ocnk/UserRegisterAuthentication";
import DashBoard from "../pages/ocnk/DashBoard";
import EconomicEstimate from "../pages/ocnk/EconomicEstimate";
import EconomicSelect from "../pages/ocnk/EconomicSelect";
import EntryTop from "../pages/ocnk/EntryTop";
import Entry from "../pages/ocnk/Entry";
import EntryConfirm from "../pages/ocnk/EntryConfirm";
import EntryCompleted from "../pages/ocnk/EntryCompleted";
import EntryCheck from "../pages/ocnk/EntryCheck";
import UseStart from "../pages/ocnk/UseStart";
import ExaminationStatus from "../pages/ocnk/ExaminationStatus";
import FinalAgreement from "../pages/ocnk/FinalAgreement";
import FinalAgreementCompleted from "../pages/ocnk/FinalAgreementCompleted";
import UseStartPrecautions from "../pages/ocnk/UseStartPrecautions";
import Inquiry from "../pages/ocnk/Inquiry";

const OcnkRouting = [
  <Route path="ocnk" element={<AgentRootBeforeRender agentPath="/ocnk" />}>
    <Route index element={<BeforeRender Component={NotFound} IsLoggedIn={false} />} />
    <Route path="user_register" element={<BeforeRender Component={UserRegister} IsLoggedIn={false} />} />
    <Route path="completed_register" element={<BeforeRender Component={CompletedRegister} IsLoggedIn={false} />} />
    <Route path="login" element={<BeforeRender Component={Login} IsLoggedIn={false} />} />
    <Route path="reset_password_mail" element={<BeforeRender Component={ResetPasswordMail} IsLoggedIn={false} />} />
    <Route
      path="reset_password_mail_completed"
      element={<BeforeRender Component={ResetPasswordMailCompleted} IsLoggedIn={false} />}
    />
    <Route path="reset_password" element={<BeforeRender Component={ResetPassword} IsLoggedIn={false} />} />
    <Route path="system_error" element={<BeforeRender Component={SystemError} IsLoggedIn={false} />} />
    <Route
      path="user_register_auth"
      element={<BeforeRender Component={UserRegisterAuthentication} IsLoggedIn={false} />}
    />
    <Route path="change_password_mail" element={<BeforeRender Component={ChangePasswordMail} />} />
    <Route path="entry_select" element={<BeforeRender Component={EntrySelect} IsLoggedIn={false} />} />
    <Route path="dashboard" element={<BeforeRender Component={DashBoard} />} />
    <Route path="economic_select" element={<BeforeRender Component={EconomicSelect} />} />
    <Route path="economic_estimate" element={<BeforeRender Component={EconomicEstimate} />} />
    <Route path="entry_top" element={<BeforeRender Component={EntryTop} />} />
    <Route path="entry" element={<BeforeRender Component={Entry} />}>
      <Route path="merchant" element={<EntryColumn path="merchant" />} />
      <Route path="bank_account" element={<EntryColumn path="bank_account" />} />
      <Route path="shop" element={<EntryColumn path="shop" />} />
    </Route>
    <Route path="entry_confirm" element={<BeforeRender Component={EntryConfirm} />} />
    <Route path="entry_completed" element={<BeforeRender Component={EntryCompleted} />} />
    <Route path="entry_check" element={<BeforeRender Component={EntryCheck} />} />
    <Route path="use_start" element={<BeforeRender Component={UseStart} />} />
    <Route path="examination_status" element={<BeforeRender Component={ExaminationStatus} />} />
    <Route path="final_agreement" element={<BeforeRender Component={FinalAgreement} />} />
    <Route path="final_agreement_completed" element={<BeforeRender Component={FinalAgreementCompleted} />} />
    <Route path="use_start_precautions" element={<BeforeRender Component={UseStartPrecautions} />} />
    <Route path="inquiry" element={<BeforeRender Component={Inquiry} />} />
  </Route>,
];

export default OcnkRouting;
